import { render, staticRenderFns } from "./Lottery.vue?vue&type=template&id=645137b6&scoped=true"
import script from "./Lottery.vue?vue&type=script&lang=js"
export * from "./Lottery.vue?vue&type=script&lang=js"
import style0 from "./Lottery.vue?vue&type=style&index=0&id=645137b6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645137b6",
  null
  
)

export default component.exports